import "react-table/react-table.css";

import { css } from "styled-components";

import { breakpoint } from "src/library/utils";

export const TableStyles = css`
  ${({ theme }) => css`
    .ReactTable-container {
      position: relative;
      width: 100%;
      padding-top: 40px;

      .table-toggles {
        position: absolute;
        z-index: 1;
        top: 8px;
        right: 0;
        width: 100%;
        justify-content: space-between;

        .toggle-right {
          display: flex;
        }
        .toggle-right > div {
          display: flex;
          align-items: center;
          padding-left: 24px;
          cursor: pointer;

          &:first-child {
            padding-left: 0;
          }

          .toggle-text {
            display: none;
            ${({ theme }) => breakpoint("sm", theme)} {
              display: inline;
            }
          }

          span,
          svg {
            transition: ${theme.transition.quickest};
          }

          span {
            padding-left: 6px;
          }

          &:hover,
          &.active {
            span {
              color: ${theme.colors.primaryDark};
            }

            svg {
              fill: ${theme.colors.primaryDark};
            }
          }
        }
      }

      .ReactTable {
        border: 0;
        width: 100%;

        .rt-tr {
          width: 100%;
        }
        .rt-table {
          /*
           * Overflow-y becomes 'auto' when combined with overflow-x: scroll.
           * Age-old problem when it comes to using overflow. Hacky way to fix
           * is to use padding + negative margin combo.
          */
          overflow-y: visible;
          overflow-x: scroll;
          overflow: scroll;
          -ms-overflow-style: scrollbar;

          ::-webkit-scrollbar {
            /* width: 12px !important; */
            height: 15px !important;

            &:hover {
              cursor: pointer;
            }
          }
          ::-webkit-scrollbar-thumb {
            border-width: 1px 1px 1px 2px;
          }
          ::-webkit-scrollbar-track {
            border-width: 0;
          }

          /*prevent bar-like colored track on hover*/
          ::-webkit-scrollbar-track {
            background-clip: padding-box;
            border: solid transparent;
            /*border-width: 0;/* 0 0 4px;*/
          }

          /*vertical track*/
          ::-webkit-scrollbar-track {
            background: transparent;
            border-width: 1px;
          }
          /*horizontal track*/
          ::-webkit-scrollbar-track:horizontal {
            border-width: 1px;
            background-color: ${theme.colors.lightGrey};
          }

          ::-webkit-scrollbar-thumb:horizontal {
            background-color: ${theme.colors.primaryDark};
          }

          /* padding-bottom: 120px; */
          /* margin-bottom: -120px; */

          .rt-thead,
          .rt-tbody {
            .rt-tr {
              padding: 10px 0;
              justify-content: space-between;

              .rt-td {
                &:first-child {
                  padding-left: 14px;
                }
              }

              .rt-th,
              .rt-td {
                overflow: visible;
                align-self: center;
                padding: 0 8px;
                font-size: ${theme.fonts.sizes.p};
                text-align: left;
                border: 0;
            
                &:last-child {
                  padding-right: 14px;
                }
              }

              .rt-td {
                &.grid-column {
                  height: 100%;
                }

                &.rt-td:not(.grid-column) {
                  width: 100%;
                  text-overflow: ellipsis;
                  overflow: hidden;
                }

                > a,
                > span {
                  width: 100%;
                  display: block;
                  text-overflow: ellipsis;
                  overflow: hidden;
                }
              }
            }
          }

          .rt-thead {
            overflow: hidden;
            position: relative;
            z-index: 2;
            box-shadow: none;
            transition: ${theme.transition.quicker};

            &.-filters {
              height: 0;
              border: 0;
              z-index: 0;

              select {
                max-height: 32px;
              }

              input {
                transition: ${theme.transition.quicker};
                border: 2px solid ${theme.colors.lightGrey};
              }

              input:focus {
                border: 2px solid ${theme.colors.primaryDark};
              }

              .rt-tr {
                padding-top: 0;
              }
            }

            .rt-th {
              .rt-resizable-header-content {
                text-transform: capitalize;
              }

              .rt-resizer {
                display: none;
                right: -12px;
              }

              &:hover {
                .rt-resizer {
                  display: block;
                }
              }

              &.-cursor-pointer {
                box-shadow: none;

                .rt-resizable-header-content {
                  &:after {
                    content: "▼";
                    padding-left: 6px;
                    color: ${theme.colors.ghost};
                    font-size: 10px;
                  }
                }

                &.-sort-asc,
                &.-sort-desc {
                  font-weight: ${theme.fonts.weights.bold};

                  .rt-resizable-header-content {
                    &:after {
                      color: ${theme.fonts.colors.primary};
                    }
                  }
                }

                &.-sort-asc {
                  .rt-resizable-header-content {
                    &:after {
                      content: "▲";
                    }
                  }
                }

                &.-sort-desc {
                  .rt-resizable-header-content {
                    &:after {
                      content: "▼";
                    }
                  }
                }
              }
            }
          }

          .rt-tbody {
            transition: ${theme.transition.quick};
            z-index: 2;
            background-color: ${theme.colors.white};
            min-height: 0;
            overflow: visible;

            .rt-tr {
              border-bottom: 1px solid ${theme.colors.ziggurat};

              .rt-td {
                .action-button-container {
                  ul {
                    right: 0;
                  }
                }
              }
            }
          }
        }

        &.no-data {
          .rt-table {
            .rt-thead {
              &.-filters {
                height: 0;
                z-index: 0;
              }
            }
          }

          .rt-tbody {
            min-height: 100px;
          }
        }

        &.loading {
          .pagination-bottom {
            opacity: 0.4;
          }

          .rt-table {
            .rt-tbody {
              min-height: 24vh;
              opacity: 0.4;
            }
          }

          .rt-no-data {
            opacity: 0;
          }
        }

        &.show-filters {
          &.loading {
            .rt-loading {
              > div {
                > div {
                  top: 22px;
                }
              }
            }
          }

          &.no-data {
            .rt-no-data {
              p {
                padding-top: 42px;
              }
            }
          }

          .rt-table {
            .rt-thead {
              &.-filters {
                z-index: 2;
                height: 42px;

                input,
                select {
                  max-width: 100%;
                }
              }
            }
          }

          .rt-error {
            padding-top: 42px;
          }
        }

        .pagination-bottom {
          .rt-pagination {
            flex-direction: column;
            .showing {
              width: 100%;
              margin-bottom: ${theme.spacing.margins.sm};
            }

            .paginator-container {
              flex-direction: column;

              .select-container {
                padding-left: 0;
                margin-top: ${theme.spacing.margins.sm};
              }
            }

            ${({ theme }) => breakpoint("md", theme)} {
              flex-direction: row;
              .showing {
                width: auto;
              }

              .paginator-container {
                flex-direction: row;

                .select-container {
                  padding-left: ${theme.spacing.margins.sm};
                  margin-top: 0;
                }
              }
            }
          }
        }
      }
      /* Grid view styles */
      &.grid-view {
        padding-top: 20px;

        .toggle-view {
        }
        .rt-thead {
          height: 0;
          overflow: hidden;
        }

        .show-filters {
          .rt-thead {
            height: auto;
            overflow: visible;
          }
        }

        .column:not(.grid-column) {
          display: none;
        }
        .grid-column {
          width: 100% !important;
          flex: auto !important;
        }
        .rt-tbody {
          min-width: 100% !important;
        }
        .rt-table .rt-tbody {
          width: 100%;
          display: flex;
          flex-direction: row;
          background-color: transparent;
          flex-wrap: wrap;
          justify-content: flex-start;
          transition: none;

          .rt-tr-group {
            padding: 0px;
            width: 100%;
            flex: 0 0;
            flex-basis: auto;

            ${({ theme }) => breakpoint("sm", theme)} {
              width: calc(100% / 2);
              flex: 0 0;
              flex-basis: auto;
            }

            ${({ theme }) => breakpoint("xl", theme)} {
              width: calc(100% / 3);
              flex: 0 0;
              flex-basis: auto;
            }

            ${({ theme }) => breakpoint("xxl", theme)} {
              width: calc(100% / 4);
              flex: 0 0;
              flex-basis: auto;
            }

            @media .rt-tr {
              border-bottom: none;
            }
          }
        }
      }
    }

    .bulk-actions-wrapper {
      margin-bottom: ${theme.spacing.margins.md};
      display: flex;
      align-items: center;

      .top-level-button {
        margin-left: ${theme.spacing.margins.md};
      }

      ${breakpoint("md", theme)} {
        align-self: flex-end;
      }
    }

    @media (max-width: 767px) {
      .ReactTable-container {
        .ReactTable {
          .rt-table {
            .rt-thead,
            .rt-tbody {
              .rt-tr {
                .rt-th,
                .rt-td {
                  font-size: ${theme.fonts.sizes.h5};
                }
              }
            }
          }
        }
      }
    }
  `}
`;
